
import useAdminPermission_ from '../common/client/hooks/mysliveckyportal/useAdminPermission';

import useUserPermissionsState from './useUserPermissionsState';

export default function useAdminPermission() {
    const userPermissionsState = useUserPermissionsState();
    return useAdminPermission_(userPermissionsState, -1);
}
